import styled from "styled-components";
import { isMobile } from "../../../common/utils";

export const LoginPinWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${isMobile ? '100%' : '476px'};
  height: 100%;
  row-gap: 32px;
  background-color: var(--allie-color-light-main);
  ${isMobile ? 'align-items: center;' : ''}
`;

export const LoginPinHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LoginPinFooter = styled.footer`
  display: flex;
  align-items: start;
  justify-content: flex-end;
  height: 58px;
`;
